import React, { useState } from "react";
import Vector from "../../assets/img/Vector.png";
import Work from "../../assets/img/work.png";
import bg1 from "../../assets/img/2019.png";
import bg2 from "../../assets/img/2020.png";
import bg3 from "../../assets/img/2021.png";
import bg4 from "../../assets/img/2023.png";
import bg5 from "../../assets/img/2024.png";
import about from "../../assets/img/abouthero.png";
import about1 from "../../assets/img/abouthero1.png";
import about2 from "../../assets/img/abouthero2.png";
import kwaku from "../../assets/img/team/kwaku.png";
import faith from "../../assets/img/team/faith.png";
import louis from "../../assets/img/team/hugo.png";
import aggrey from "../../assets/img/team/aggrey.png";
import alice from "../../assets/img/team/alice.png";
import john from "../../assets/img/team/john.png";
import tom from "../../assets/img/team/tom.png";
import stephen from "../../assets/img/team/stephen.png";
import check1 from "../../assets/img/check1.png";
import check3 from "../../assets/img/check3.png";
import ReactGA from "react-ga";
import OpenAccount from "../../components/OpenAccount";
import "./about.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const AboutPage = () => {
  const aboutData = useSelector(
    (state) =>
      state.combined.aboutData || {
        clientCount: 20000,
        fundCount: 8,
        totalAmount: 120000000,
      }
  );
  React.useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);
  const rows = {
    1: [
      {
        label: "Safety and security of savings",
        cashlet: check3,
        banks: check1,
        telcos: check1,
      },
      { label: "“Great” savings rate (Double digits)", cashlet: check3 },
      {
        label: "Affordable starting amounts and top-ups (KES 100 or less)",
        cashlet: check3,
        telcos: check1,
      },
      {
        label: "Instant access to savings and no withdrawal limits",
        cashlet: check3,
        telcos: check1,
      },
      {
        label: "Convenient and fully digital signup, cash-in & cash-out",
        cashlet: check3,
        telcos: check1,
      },
      { label: "Tracks and monitor growth in savings", cashlet: check3 },
      { label: "Choose from multiple saving products", cashlet: check3 },
      {
        label: "Saving tools (unlimited goals, lock goals, group goals, etc)",
        cashlet: check3,
      },
      { label: "Savings-linked loans", cashlet: check3, telcos: check1 },
    ],
    2: [
      {
        label: "Safety and security of savings",
        cashlet: check3,
        saccos: check1,
        fundManagers: check1,
      },
      {
        label: "“Great” savings rate (Double digits)",
        cashlet: check3,
        saccos: check1,
        fundManagers: check1,
      },
      {
        label: "Affordable starting amounts and top-ups (KES 100 or less)",
        cashlet: check3,
      },
      {
        label: "Instant access to savings and no withdrawal limits",
        cashlet: check3,
      },
      {
        label: "Convenient and fully digital signup, cash-in & cash-out",
        cashlet: check3,
      },
      { label: "Tracks and monitor growth in savings", cashlet: check3 },
      { label: "Choose from multiple saving products", cashlet: check3 },
      {
        label: "Saving tools (unlimited goals, lock goals, group goals, etc)",
        cashlet: check3,
      },
      { label: "Savings-linked loans", cashlet: check3, saccos: check1 },
    ],
    3: [
      { label: "Safety and security of savings", cashlet: check3 },
      { label: "“Great” savings rate (Double digits)", cashlet: check3 },
      {
        label: "Affordable starting amounts and top-ups (KES 100 or less)",
        cashlet: check3,
        other: check1,
      },
      {
        label: "Instant access to savings and no withdrawal limits",
        cashlet: check3,
      },
      {
        label: "Convenient and fully digital signup, cash-in & cash-out",
        cashlet: check3,
        other: check1,
      },
      { label: "Tracks and monitor growth in savings", cashlet: check3 },
      { label: "Choose from multiple saving products", cashlet: check3 },
      {
        label: "Saving tools (unlimited goals, lock goals, group goals, etc)",
        cashlet: check3,
        other: check1,
      },
      { label: "Savings-linked loans", cashlet: check3 },
    ],
  };
  const headers = {
    1: ["", "Cashlet", "Banks", "Telcos"],
    2: ["", "Cashlet", "Saccos", "Fund Managers"],
    3: ["", "Cashlet", "Other Saving Apps"],
  };
  const [page, setPage] = useState(1);
  const nextPage = () => {
    if (page === 3) setPage(1);
    else setPage(page + 1);
  };
  const prevPage = () => {
    if (page === 1) setPage(3);
    else setPage(page - 1);
  };
  const members1 = [
    {
      name: "Kwaku Debrah",
      img: kwaku,
      bg: "#A6F4C5",
      desc: "CEO",
      instagram: "https://x.com/kwakudeb?lang=en",
      linkedin: "https://www.linkedin.com/in/kwaku-debrah-45737621/",
    },
    {
      name: "Aggrey Obimbo",
      img: stephen,
      bg: "#A7E3EB",
      desc: "Chief Commercial Officer",
      linkedin: "https://www.linkedin.com/in/aggrey-lutsinga/",
    },
    {
      name: "Alice Muge",
      img: alice,
      bg: "#FFBA93",
      desc: "Legal and Regulatory",
      linkedin: " https://www.linkedin.com/in/alice-wairimu-mugo-18205a21/",
    },
    {
      name: "Faith Gachagwi",
      img: faith,
      bg: "#CBB2EB",
      desc: "Customer Experience",
      linkedin: "https://www.linkedin.com/in/faith-nyaruiru-562193196/",
    },
  ];
  const members2 = [
    { name: "John Otieno", img: john, bg: "#52AFB6", desc: "Finance" },
    {
      name: "Tom Osebe",
      img: tom,
      bg: "#A6F4C5",
      desc: "Director",
      linkedin:
        "https://www.linkedin.com/in/tom-osebe-phd-prince2%C2%AE-52264834/",
    },
    {
      name: "Louis Hugo",
      img: louis,
      bg: "#A7E3EB",
      desc: "Technology",
      linkedin: "https://www.linkedin.com/in/louismuriuki/",
    },
    {
      name: "Stephen Mwachala",
      img: aggrey,
      bg: "#FFBA93",
      desc: "Technology",
    },
  ];
  function formatNumber(num) {
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1) + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "K";
    } else {
      return num.toString();
    }
  }

  return (
    <>
      {/* SECTION 1 */}
      <div className="overflow-hidden mx-4 md:mx-[78px] flex items-center justify-center h-[44vh] lg:h-[70vh] about-landing">
        <div className="lg:container flex justify-center items-center">
          <h1 className="z-20 ml-[10px] md:ml-[160px] mt-40 md:mt-72 about-heading text-[26px] lg:text-[50px] slide-in-bottom-h1 text-white lg:w-[60%] px-2 lg:px-0 mx-auto">
            Making it easy for everyone to <br />
            manage, grow, and take control <br />
            over their money
          </h1>
        </div>
      </div>
      {/* SECTION 2*/}
      <div className="overflow-hidden lg:container mx-auto flex flex-col md:flex-row items-start py-16 md:py-24 lg:py-30 gap-4">
        <div className="flex flex-col gap-8 sm:w-full lg:w-3/4 justify-center lg:items-start overflow-y-hidden px-8 text-left">
          <h1
            className="text-3xl lg:text-5xl slide-in-bottom-h1 uppercase font-black"
            style={{ color: "#232426" }}
          >
            Why we come to work everyday
          </h1>
          <div className="text-base lg:text-xl text-muted slide-in-bottom-subtitle sm:w-full lg:w-4/5 leading-6 lg:leading-8">
            We’re building the savings and investment super app of the future
            that provides people with easy and convenient tools to manage, grow,
            and monitor their money so that they can achieve their financial
            goals.
          </div>
          <div className="text-base lg:text-xl text-muted slide-in-bottom-subtitle sm:w-full lg:w-4/5 leading-6 lg:leading-8">
            Cashlet is the savings and investing product of Sycamore Capital
            Kenya Ltd, and is authorized and regulated by the Capital Markets
            Authority (CMA) – the regulatory body in Kenya. Our platform offers
            savings and money market funds from ICEA Lion Asset Management,
            Etica Capital, Orient Asset Managers, and Nabo Capital. These
            products ensure stability, high interest, and easy liquidity.
          </div>
        </div>
        <div className="sm:w-full lg:w-1/4 mx-auto">
          <img
            className="object-contain w-94 mr-auto"
            src={Work}
            alt="work"
            loading="lazy"
          />
        </div>
      </div>
      {/* SECTION 3 */}
      <div className="overflow-hidden lg:container mx-auto text-center pt-4 pb-8">
        <h1
          className="text-3xl lg:text-5xl slide-in-bottom-h1 text-left mb-10 uppercase px-8 font-black"
          style={{ color: "#232426" }}
        >
          Our value proposition is unique
        </h1>
        <div className="my-4 hidden lg:block px-8">
          <table className="w-full table-auto divide-y divide-gray-600 text-left table-border-top">
            <thead>
              <tr>
                {[
                  "",
                  "Cashlet",
                  "Banks",
                  "Telcos",
                  "Saccos",
                  "Fund Managers",
                  "Other Saving Apps",
                ]?.map((el, i) => (
                  <th
                    key={i}
                    scope="col"
                    className="px-2 py-3 font-bold text-black tracking-wider"
                    style={{
                      borderRightWidth: i === 6 ? "0px" : "1px",
                      background: i === 1 ? "#20E083" : "",
                    }}
                  >
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-600">
              {[
                {
                  label: "Safety and security of savings",
                  cashlet: check3,
                  banks: check1,
                  telcos: check1,
                  saccos: check1,
                  fundManagers: check1,
                },
                {
                  label: "“Great” savings rate (Double digits)",
                  cashlet: check3,
                  saccos: check1,
                  fundManagers: check1,
                },
                {
                  label:
                    "Affordable starting amounts and top-ups (KES 100 or less)",
                  cashlet: check3,
                  telcos: check1,
                  other: check1,
                },
                {
                  label: "Instant access to savings and no withdrawal limits",
                  cashlet: check3,
                  telcos: check1,
                },
                {
                  label:
                    "Convenient and fully digital signup, cash-in & cash-out",
                  cashlet: check3,
                  telcos: check1,
                  other: check1,
                },
                {
                  label: "Tracks and monitor growth in savings",
                  cashlet: check3,
                },
                {
                  label: "Choose from multiple saving products",
                  cashlet: check3,
                },
                {
                  label:
                    "Saving tools (unlimited goals, lock goals, group goals, etc)",
                  cashlet: check3,
                  other: check1,
                },
                {
                  label: "Savings-linked loans",
                  cashlet: check3,
                  telcos: check1,
                  saccos: check1,
                },
              ]?.map((el, i) => (
                <tr key={i}>
                  <td className="px-2 py-3 border-r table-border ">
                    {el.label}
                  </td>
                  <td
                    className="px-2 py-3  border-r table-border"
                    style={{ background: "#20E083" }}
                  >
                    <img
                      src={el.cashlet}
                      alt="cashlet bg"
                      className="mx-auto"
                      loading="lazy"
                    />
                  </td>
                  <td className="px-2 py-3 border-r  table-border">
                    {el.banks && (
                      <img
                        src={el.banks}
                        alt="banks bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    )}
                  </td>
                  <td className="px-2 py-3 border-r  table-border">
                    {el.telcos && (
                      <img
                        src={el.telcos}
                        alt="telcos bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    )}
                  </td>
                  <td className="px-2 py-3 border-r  table-border">
                    {el.saccos && (
                      <img
                        src={el.saccos}
                        alt="saccos bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    )}
                  </td>
                  <td className="px-2 py-3 border-r  table-border">
                    {el.fundManagers && (
                      <img
                        src={el.fundManagers}
                        alt="fundManagers bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    )}
                  </td>
                  <td className="px-2 py-3 table-border">
                    {el.other && (
                      <img
                        src={el.other}
                        alt="other bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="lg:hidden">
          <div className="px-2 py-3 font-bold text-black flex justify-end items-center gap-4 w-full table-border bo">
            {page === 1 && (
              <div className="cusor-pointer">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <g opacity="0.3">
                    <rect
                      x="31.3846"
                      y="32.08"
                      width="30.7692"
                      height="30.7692"
                      rx="15.3846"
                      transform="rotate(-180 31.3846 32.08)"
                      stroke="black"
                      strokeWidth="1.23077"
                    />
                    <path
                      d="M6.37869 17.0717L13.3018 10.1487C13.4461 10.0043 13.6419 9.92324 13.846 9.92324C14.0501 9.92324 14.2459 10.0043 14.3902 10.1487C14.5346 10.293 14.6157 10.4888 14.6157 10.6929C14.6157 10.897 14.5346 11.0928 14.3902 11.2371L8.77966 16.8467H23.846C24.05 16.8467 24.2457 16.9278 24.3899 17.0721C24.5342 17.2163 24.6152 17.412 24.6152 17.616C24.6152 17.82 24.5342 18.0156 24.3899 18.1599C24.2457 18.3042 24.05 18.3852 23.846 18.3852H8.77966L14.3902 23.9948C14.5346 24.1392 14.6157 24.3349 14.6157 24.5391C14.6157 24.7432 14.5346 24.9389 14.3902 25.0833C14.2459 25.2276 14.0501 25.3087 13.846 25.3087C13.6419 25.3087 13.4461 25.2276 13.3018 25.0833L6.37869 18.1602C6.30717 18.0888 6.25044 18.0039 6.21173 17.9105C6.17302 17.8172 6.15309 17.7171 6.15309 17.616C6.15309 17.5149 6.17302 17.4148 6.21173 17.3214C6.25044 17.228 6.30717 17.1432 6.37869 17.0717Z"
                      fill="black"
                    />
                  </g>
                </svg>
              </div>
            )}
            {page !== 1 && (
              <div
                className="cusor-pointer rotate-180"
                onClick={() => prevPage()}
              >
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <rect
                    x="0.615385"
                    y="1.31082"
                    width="30.7692"
                    height="30.7692"
                    rx="15.3846"
                    fill="white"
                  />
                  <rect
                    x="0.615385"
                    y="1.31082"
                    width="30.7692"
                    height="30.7692"
                    rx="15.3846"
                    stroke="black"
                    strokeWidth="1.23077"
                  />
                  <path
                    d="M24.3908 17.5496L17.4678 24.4727C17.3234 24.617 17.1277 24.6981 16.9235 24.6981C16.7194 24.6981 16.5236 24.617 16.3793 24.4727C16.235 24.3283 16.1539 24.1326 16.1539 23.9284C16.1539 23.7243 16.235 23.5285 16.3793 23.3842L21.9899 17.7746H6.92353C6.71951 17.7746 6.52386 17.6935 6.3796 17.5493C6.23534 17.405 6.1543 17.2094 6.1543 17.0054C6.1543 16.8013 6.23534 16.6057 6.3796 16.4614C6.52386 16.3172 6.71951 16.2361 6.92353 16.2361H21.9899L16.3793 10.6265C16.235 10.4822 16.1539 10.2864 16.1539 10.0823C16.1539 9.87815 16.235 9.68239 16.3793 9.53805C16.5236 9.39371 16.7194 9.31262 16.9235 9.31262C17.1277 9.31262 17.3234 9.39371 17.4678 9.53805L24.3908 16.4611C24.4624 16.5326 24.5191 16.6174 24.5578 16.7108C24.5965 16.8042 24.6164 16.9043 24.6164 17.0054C24.6164 17.1064 24.5965 17.2065 24.5578 17.2999C24.5191 17.3933 24.4624 17.4781 24.3908 17.5496Z"
                    fill="black"
                  />
                </svg>
              </div>
            )}
            {[{}, {}, {}]?.map((_, ind) => (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                onClick={() => setPage(ind + 1)}
                key={ind}
              >
                <circle
                  cx="6.5"
                  cy="6.69543"
                  r="6"
                  fill="#232426"
                  fillOpacity={page === ind + 1 ? "1" : "0.2"}
                />
              </svg>
            ))}
            {page !== 3 && (
              <div className="cusor-pointer" onClick={() => nextPage()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <rect
                    x="0.615385"
                    y="1.31082"
                    width="30.7692"
                    height="30.7692"
                    rx="15.3846"
                    fill="white"
                  />
                  <rect
                    x="0.615385"
                    y="1.31082"
                    width="30.7692"
                    height="30.7692"
                    rx="15.3846"
                    stroke="black"
                    strokeWidth="1.23077"
                  />
                  <path
                    d="M24.3908 17.5496L17.4678 24.4727C17.3234 24.617 17.1277 24.6981 16.9235 24.6981C16.7194 24.6981 16.5236 24.617 16.3793 24.4727C16.235 24.3283 16.1539 24.1326 16.1539 23.9284C16.1539 23.7243 16.235 23.5285 16.3793 23.3842L21.9899 17.7746H6.92353C6.71951 17.7746 6.52386 17.6935 6.3796 17.5493C6.23534 17.405 6.1543 17.2094 6.1543 17.0054C6.1543 16.8013 6.23534 16.6057 6.3796 16.4614C6.52386 16.3172 6.71951 16.2361 6.92353 16.2361H21.9899L16.3793 10.6265C16.235 10.4822 16.1539 10.2864 16.1539 10.0823C16.1539 9.87815 16.235 9.68239 16.3793 9.53805C16.5236 9.39371 16.7194 9.31262 16.9235 9.31262C17.1277 9.31262 17.3234 9.39371 17.4678 9.53805L24.3908 16.4611C24.4624 16.5326 24.5191 16.6174 24.5578 16.7108C24.5965 16.8042 24.6164 16.9043 24.6164 17.0054C24.6164 17.1064 24.5965 17.2065 24.5578 17.2999C24.5191 17.3933 24.4624 17.4781 24.3908 17.5496Z"
                    fill="black"
                  />
                </svg>
              </div>
            )}
            {page === 3 && (
              <div className="cusor-pointer rotate-180">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <g opacity="0.3">
                    <rect
                      x="31.3846"
                      y="32.08"
                      width="30.7692"
                      height="30.7692"
                      rx="15.3846"
                      transform="rotate(-180 31.3846 32.08)"
                      stroke="black"
                      strokeWidth="1.23077"
                    />
                    <path
                      d="M6.37869 17.0717L13.3018 10.1487C13.4461 10.0043 13.6419 9.92324 13.846 9.92324C14.0501 9.92324 14.2459 10.0043 14.3902 10.1487C14.5346 10.293 14.6157 10.4888 14.6157 10.6929C14.6157 10.897 14.5346 11.0928 14.3902 11.2371L8.77966 16.8467H23.846C24.05 16.8467 24.2457 16.9278 24.3899 17.0721C24.5342 17.2163 24.6152 17.412 24.6152 17.616C24.6152 17.82 24.5342 18.0156 24.3899 18.1599C24.2457 18.3042 24.05 18.3852 23.846 18.3852H8.77966L14.3902 23.9948C14.5346 24.1392 14.6157 24.3349 14.6157 24.5391C14.6157 24.7432 14.5346 24.9389 14.3902 25.0833C14.2459 25.2276 14.0501 25.3087 13.846 25.3087C13.6419 25.3087 13.4461 25.2276 13.3018 25.0833L6.37869 18.1602C6.30717 18.0888 6.25044 18.0039 6.21173 17.9105C6.17302 17.8172 6.15309 17.7171 6.15309 17.616C6.15309 17.5149 6.17302 17.4148 6.21173 17.3214C6.25044 17.228 6.30717 17.1432 6.37869 17.0717Z"
                      fill="black"
                    />
                  </g>
                </svg>
              </div>
            )}
          </div>
          <table className="w-full table-auto divide-y divide-gray-600 text-left table-border">
            <thead>
              <tr>
                {headers?.[page]?.map((el, i) => (
                  <th
                    key={i}
                    scope="col"
                    className="px-2 py-3 font-bold text-black tracking-wider"
                    style={{
                      borderRightWidth: "1px",
                      background: i === 1 && page === 1 ? "#20E083" : "",
                    }}
                  >
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-600">
              {rows?.[page]?.map((el, i) => (
                <tr key={i}>
                  <td className="px-2 py-3 border-r table-border ">
                    {el.label}
                  </td>
                  {
                    <td
                      className="px-2 py-3  border-r table-border"
                      style={{ background: "#20E083" }}
                    >
                      <img
                        src={el.cashlet}
                        alt="cashlet bg"
                        className="mx-auto"
                        loading="lazy"
                      />
                    </td>
                  }
                  {page === 1 && (
                    <td className="px-2 py-3 border-r  table-border">
                      {el.banks && (
                        <img
                          src={el.banks}
                          alt="banks bg"
                          className="mx-auto"
                          loading="lazy"
                        />
                      )}
                    </td>
                  )}
                  {page === 1 && (
                    <td className="px-2 py-3 border-r  table-border">
                      {el.telcos && (
                        <img
                          src={el.telcos}
                          alt="telcos bg"
                          className="mx-auto"
                          loading="lazy"
                        />
                      )}
                    </td>
                  )}

                  {page === 2 && (
                    <td className="px-2 py-3 border-r  table-border">
                      {el.saccos && (
                        <img
                          src={el.saccos}
                          alt="saccos bg"
                          className="mx-auto"
                          loading="lazy"
                        />
                      )}
                    </td>
                  )}
                  {page === 2 && (
                    <td className="px-2 py-3 border-r  table-border">
                      {el.fundManagers && (
                        <img
                          src={el.fundManagers}
                          alt="fundManagers bg"
                          className="mx-auto"
                          loading="lazy"
                        />
                      )}
                    </td>
                  )}
                  {page === 3 && (
                    <td className="px-2 py-3 table-border">
                      {el.other && (
                        <img
                          src={el.other}
                          alt="other bg"
                          className="mx-auto"
                          loading="lazy"
                        />
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* SECTION 4 */}
      <div
        style={{ background: "#F1EEE4", position: "relative" }}
        className="my-16 md:my-24 lg:my-36"
      >
        <img
          src={Vector}
          alt="vector"
          className="hidden md:block"
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
            bottom: 0,
            width: "25%",
            height: "100%",
          }}
          loading="lazy"
        />
        <div className="overflow-hidden lg:container mx-auto py-12">
          <h1
            className="text-3xl lg:text-4xl slide-in-bottom-h1 uppercase text-center mb-4 lg:mb-20"
            style={{ color: "#232426" }}
          >
            Cashlet in numbers
          </h1>
          <div className="flex flex-col md:flex-row sm:flex-wrap md:flex-nowrap gap-y-8 gap-x-8 md:gap-x-32 w-full justify-center items-center overflow-hidden px-8">
            {[
              {
                key: formatNumber(aboutData.clientCount),
                val: "Customers in Kenya",
              },
              {
                key: `KES ${formatNumber(aboutData.totalAmount)}`,
                val: "Set aside, saved and invested",
              },
              {
                key: formatNumber(aboutData.fundCount),
                val: "Money market funds",
              },
            ]?.map((el, i) => (
              <div key={i} className="text-center z-10">
                <h1
                  className="text-5xl lg:text-8xl slide-in-bottom-h1 uppercase"
                  style={{ color: "#5B8266" }}
                >
                  {el.key}
                </h1>
                <p
                  className="text-base lg:text-lg text-muted slide-in-bottom-subtitle"
                  style={{ color: "#212922" }}
                >
                  {el.val}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* SECTION 5 */}
      <div className="px-6">
        <h1
          className="text-3xl lg:text-4xl uppercase font-black slide-in-bottom-h1 text-left md:text-center my-8"
          style={{ color: "#232426" }}
        >
          A journey through our evolution
        </h1>
        <div className="flex justify-center gap-6 items-start pb-6 flex-wrap md:flex-nowrap">
          {[
            {
              title: "Founded in April, 2019",
              img: bg1,
              desc: "Cashlet was founded in Nairobi, Kenya, with a strong entrepreneurial spirit, and a mission to help everyone to save, invest, and manage their money better.",
            },
            {
              title: "Initial partnership agreement",
              img: bg2,
              desc: "Penned a partnership agreement with our first partner fund manager - ICEA Lion Asset Management",
            },
            {
              title: "CMA Sandbox admission",
              img: bg3,
              desc: "Obtained approval from the Capital Markets Authority (CMA) in Kenya to the join the regulatory Sandbox for Innovative Fintechs",
            },
          ]?.map((el, i) => (
            <div
              key={i}
              style={{
                borderRadius: "24px",
                border: "1px solid #DCDEDC",
                borderTop: "0px",
                background: "#F7F7F7",
                display: "flex",
                flexDirection: "column",
                width: "350px",
                height: "100%",
              }}
            >
              <img
                style={{
                  borderRadius: "24px 24px 0px 0px",
                  height: "240px",
                }}
                src={el.img}
                alt="img"
                loading="lazy"
              />
              <div
                className="flex flex-col p-6"
                style={{
                  height: "250px",
                }}
              >
                <p
                  className="m-0 mb-4 font-medium text-xl lg:text-2xl"
                  style={{ color: "#232426" }}
                >
                  {el.title}
                </p>
                <p className="m-0 text-base" style={{ color: "#505A63" }}>
                  {el.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center gap-6 items-start flex-wrap md:flex-nowrap">
          {[
            {
              title: "Additional partner fund managers",
              img: bg4,
              desc: "Signed partnerships with Etica Capital and Orient Asset Managers, expanding our platform to 4 money market funds.",
            },
            {
              title: "CMA Sandbox Exit",
              img: bg5,
              desc: "Successfully exited from the CMA Sandbox",
            },
          ]?.map((el, i) => (
            <div
              key={i}
              style={{
                borderRadius: "24px",
                border: "1px solid #DCDEDC",
                borderTop: "0px",
                background: "#F7F7F7",
                display: "flex",
                flexDirection: "column",
                width: "350px",
                height: "100%",
              }}
            >
              <img
                style={{
                  borderRadius: "24px 24px 0px 0px",
                  height: "240px",
                }}
                src={el.img}
                alt="img"
                loading="lazy"
              />
              <div
                className="flex flex-col p-6"
                style={{
                  height: "250px",
                }}
              >
                <p
                  className="m-0 mb-4 font-medium text-xl lg:text-2xl"
                  style={{ color: "#232426" }}
                >
                  {el.title}
                </p>
                <p className="m-0 text-base" style={{ color: "#505A63" }}>
                  {el.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* SECTION 6 */}
      <div className="px-4 mt-4 mb-8 lg:my-36">
        <h1
          className="text-3xl lg:text-4xl uppercase font-black slide-in-bottom-h1 text-center my-8"
          style={{ color: "#232426" }}
        >
          meet the team
        </h1>
        <div className="flex justify-center gap-6 items-start pb-6 flex-wrap md:flex-nowrap">
          {members1?.map((el, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "230px",
                height: "100%",
                borderRadius: "20.047px",
                border: "0.835px solid rgba(113, 135, 156, 0.10)",
                background: "rgba(255, 255, 255, 0.00)",
                boxShadow: "0px 1.211px 0px 0px rgba(113, 135, 156, 0.10)",
                borderTop: "0px",
              }}
            >
              <div
                style={{
                  height: "200px",
                  borderRadius: "24px 24px 0px 0px",
                  background: `${el.bg}`,
                  overflow: "hidden",
                }}
              >
                <img
                  src={el.img}
                  className="mx-auto object-cover w-full h-full"
                  alt="img"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col p-2">
                <div
                  className="m-0 font-medium text-xl lg:text-2xl"
                  style={{
                    color: "#232426",
                    fontSize: "13.26px",
                  }}
                >
                  {el.name}
                </div>
                <div
                  className="m-0 text-base"
                  style={{ color: "#71879C", fontSize: "11.694px" }}
                >
                  {el.desc}
                </div>
                <div className="flex justify-end h-5">
                  {el.instagram && (
                    <a
                      href={el.instagram}
                      className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                      type="button"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1_2988)">
                          <path
                            d="M10.0009 20.0858C15.5237 20.0858 20.0008 15.6086 20.0008 10.0858C20.0008 4.56305 15.5237 0.0859375 10.0009 0.0859375C4.47809 0.0859375 0.000976562 4.56305 0.000976562 10.0858C0.000976562 15.6086 4.47809 20.0858 10.0009 20.0858Z"
                            fill="black"
                          />
                          <path
                            d="M16.1262 7.27225C15.6976 7.46228 15.2367 7.5908 14.7532 7.6482C15.2468 7.35247 15.6256 6.88454 15.8044 6.32606C15.3425 6.60004 14.8308 6.7988 14.2865 6.90593C13.8505 6.44157 13.2293 6.15137 12.5414 6.15137C11.2216 6.15137 10.1511 7.22181 10.1511 8.54163C10.1511 8.72898 10.1724 8.91133 10.2134 9.08638C8.22684 8.98674 6.46548 8.0352 5.28648 6.58863C5.08077 6.94158 4.96276 7.35247 4.96276 7.79045C4.96276 8.61953 5.38506 9.35145 6.02607 9.77998C5.63444 9.76768 5.26562 9.6602 4.94351 9.48069C4.94333 9.49085 4.94333 9.50101 4.94333 9.51099C4.94333 10.6691 5.7676 11.6351 6.86085 11.8546C6.66049 11.9095 6.4489 11.9385 6.23125 11.9385C6.07688 11.9385 5.92732 11.9237 5.7815 11.8959C6.08561 12.8453 6.96817 13.5364 8.01436 13.5558C7.19616 14.197 6.16565 14.579 5.04548 14.579C4.85296 14.579 4.66222 14.5678 4.47559 14.5455C5.53283 15.224 6.78955 15.6195 8.13932 15.6195C12.5359 15.6195 14.9402 11.9774 14.9402 8.81846C14.9402 8.71489 14.9379 8.61168 14.9333 8.50936C15.4007 8.17246 15.8058 7.75159 16.1262 7.27225Z"
                            fill="#F1F2F2"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_2988">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0 0.0859375)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  )}
                  {el.linkedin && (
                    <a
                      href={el.linkedin}
                      className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                      type="button"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1_2740)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.8366 16.784H14.3586V12.9068C14.3586 11.9825 14.3433 10.7936 13.0709 10.7936C11.7825 10.7936 11.5855 11.8008 11.5855 12.8414V16.784H9.11024V8.81186H11.4859V9.90191H11.52C11.8507 9.27545 12.6588 8.61418 13.8637 8.61418C16.373 8.61418 16.8359 10.2646 16.8359 12.4119V16.784H16.8366ZM6.31691 7.72321C5.93569 7.72321 5.57008 7.57177 5.30052 7.30221C5.03096 7.03265 4.87952 6.66704 4.87952 6.28582C4.87952 5.90461 5.03096 5.539 5.30052 5.26944C5.57008 4.99988 5.93569 4.84844 6.31691 4.84844C6.69813 4.84844 7.06373 4.99988 7.33329 5.26944C7.60286 5.539 7.75429 5.90461 7.75429 6.28582C7.75429 6.66704 7.60286 7.03265 7.33329 7.30221C7.06373 7.57177 6.69813 7.72321 6.31691 7.72321ZM7.55661 16.784H5.07721V8.81186H7.55661V16.784ZM18.6102 2.54932H3.29666C3.11205 2.54932 2.935 2.62265 2.80446 2.75319C2.67392 2.88373 2.60059 3.06078 2.60059 3.24539V18.5589C2.60059 18.7436 2.67392 18.9206 2.80446 19.0511C2.935 19.1817 3.11205 19.255 3.29666 19.255H18.6102C18.7948 19.255 18.9719 19.1817 19.1024 19.0511C19.2329 18.9206 19.3063 18.7436 19.3063 18.5589V3.24539C19.3063 3.06078 19.2329 2.88373 19.1024 2.75319C18.9719 2.62265 18.7948 2.54932 18.6102 2.54932V2.54932Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_2740">
                            <rect
                              width="20.0468"
                              height="20.0468"
                              fill="white"
                              transform="translate(0.929688 0.880371)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center gap-6 items-start flex-wrap md:flex-nowrap">
          {members2?.map((el, i) => (
            <div
              key={i}
              style={{
                borderRadius: "24px",
                border: "1px solid #DCDEDC",
                borderTop: "0px",
                background: "#F7F7F7",
                display: "flex",
                flexDirection: "column",
                width: "230px",
                height: "100%",
              }}
            >
              <div
                style={{
                  height: "200px",
                  borderRadius: "24px 24px 0px 0px",
                  background: `${el.bg}`,
                  overflow: "hidden",
                }}
              >
                <img
                  src={el.img}
                  className="mx-auto object-cover w-full"
                  alt="img"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col p-2">
                <div
                  className="m-0 font-medium text-xl lg:text-2xl"
                  style={{
                    color: "#232426",
                    fontSize: "13.26px",
                  }}
                >
                  {el.name}
                </div>
                <div
                  className="m-0 text-base"
                  style={{ color: "#71879C", fontSize: "11.694px" }}
                >
                  {el.desc}
                </div>
                <div className="flex justify-end h-5">
                  {el.instagram && (
                    <a
                      href={el.instagram}
                      className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                      type="button"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1_2737)">
                          <path
                            d="M10.2239 2.54932C12.4934 2.54932 12.7766 2.55767 13.667 2.59943C14.5566 2.6412 15.1621 2.78069 15.6951 2.98784C16.2463 3.2 16.7108 3.48734 17.1752 3.95092C17.5999 4.36848 17.9286 4.87357 18.1383 5.43105C18.3446 5.96313 18.4849 6.56954 18.5267 7.45912C18.5659 8.34953 18.5768 8.6327 18.5768 10.9022C18.5768 13.1716 18.5684 13.4548 18.5267 14.3452C18.4849 15.2348 18.3446 15.8404 18.1383 16.3733C17.9292 16.9311 17.6004 17.4363 17.1752 17.8534C16.7575 18.278 16.2525 18.6066 15.6951 18.8165C15.163 19.0228 14.5566 19.1631 13.667 19.2049C12.7766 19.2442 12.4934 19.255 10.2239 19.255C7.95447 19.255 7.67131 19.2467 6.7809 19.2049C5.89132 19.1631 5.28574 19.0228 4.75283 18.8165C4.19513 18.6072 3.68995 18.2785 3.2727 17.8534C2.84788 17.4359 2.51922 16.9308 2.30962 16.3733C2.10247 15.8412 1.96298 15.2348 1.92121 14.3452C1.88195 13.4548 1.87109 13.1716 1.87109 10.9022C1.87109 8.6327 1.87945 8.34953 1.92121 7.45912C1.96298 6.56871 2.10247 5.96396 2.30962 5.43105C2.51864 4.87323 2.84738 4.368 3.2727 3.95092C3.69007 3.52596 4.19521 3.19727 4.75283 2.98784C5.28574 2.78069 5.89048 2.6412 6.7809 2.59943C7.67131 2.56018 7.95447 2.54932 10.2239 2.54932ZM10.2239 6.72574C9.11629 6.72574 8.054 7.16576 7.27076 7.94899C6.48753 8.73222 6.04752 9.79451 6.04752 10.9022C6.04752 12.0098 6.48753 13.0721 7.27076 13.8553C8.054 14.6386 9.11629 15.0786 10.2239 15.0786C11.3316 15.0786 12.3939 14.6386 13.1771 13.8553C13.9604 13.0721 14.4004 12.0098 14.4004 10.9022C14.4004 9.79451 13.9604 8.73222 13.1771 7.94899C12.3939 7.16576 11.3316 6.72574 10.2239 6.72574ZM15.6533 6.51692C15.6533 6.24001 15.5433 5.97443 15.3475 5.77863C15.1517 5.58282 14.8861 5.47281 14.6092 5.47281C14.3323 5.47281 14.0667 5.58282 13.8709 5.77863C13.6751 5.97443 13.5651 6.24001 13.5651 6.51692C13.5651 6.79383 13.6751 7.05941 13.8709 7.25521C14.0667 7.45102 14.3323 7.56103 14.6092 7.56103C14.8861 7.56103 15.1517 7.45102 15.3475 7.25521C15.5433 7.05941 15.6533 6.79383 15.6533 6.51692ZM10.2239 8.39631C10.8885 8.39631 11.5259 8.66032 11.9958 9.13026C12.4658 9.6002 12.7298 10.2376 12.7298 10.9022C12.7298 11.5668 12.4658 12.2041 11.9958 12.6741C11.5259 13.144 10.8885 13.408 10.2239 13.408C9.55935 13.408 8.92197 13.144 8.45204 12.6741C7.9821 12.2041 7.71809 11.5668 7.71809 10.9022C7.71809 10.2376 7.9821 9.6002 8.45204 9.13026C8.92197 8.66032 9.55935 8.39631 10.2239 8.39631Z"
                            fill="#17191E"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_2737">
                            <rect
                              width="20.0468"
                              height="20.0468"
                              fill="white"
                              transform="translate(0.200195 0.880371)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  )}
                  {el.linkedin && (
                    <a
                      href={el.linkedin}
                      className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                      type="button"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1_2740)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.8366 16.784H14.3586V12.9068C14.3586 11.9825 14.3433 10.7936 13.0709 10.7936C11.7825 10.7936 11.5855 11.8008 11.5855 12.8414V16.784H9.11024V8.81186H11.4859V9.90191H11.52C11.8507 9.27545 12.6588 8.61418 13.8637 8.61418C16.373 8.61418 16.8359 10.2646 16.8359 12.4119V16.784H16.8366ZM6.31691 7.72321C5.93569 7.72321 5.57008 7.57177 5.30052 7.30221C5.03096 7.03265 4.87952 6.66704 4.87952 6.28582C4.87952 5.90461 5.03096 5.539 5.30052 5.26944C5.57008 4.99988 5.93569 4.84844 6.31691 4.84844C6.69813 4.84844 7.06373 4.99988 7.33329 5.26944C7.60286 5.539 7.75429 5.90461 7.75429 6.28582C7.75429 6.66704 7.60286 7.03265 7.33329 7.30221C7.06373 7.57177 6.69813 7.72321 6.31691 7.72321ZM7.55661 16.784H5.07721V8.81186H7.55661V16.784ZM18.6102 2.54932H3.29666C3.11205 2.54932 2.935 2.62265 2.80446 2.75319C2.67392 2.88373 2.60059 3.06078 2.60059 3.24539V18.5589C2.60059 18.7436 2.67392 18.9206 2.80446 19.0511C2.935 19.1817 3.11205 19.255 3.29666 19.255H18.6102C18.7948 19.255 18.9719 19.1817 19.1024 19.0511C19.2329 18.9206 19.3063 18.7436 19.3063 18.5589V3.24539C19.3063 3.06078 19.2329 2.88373 19.1024 2.75319C18.9719 2.62265 18.7948 2.54932 18.6102 2.54932V2.54932Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_2740">
                            <rect
                              width="20.0468"
                              height="20.0468"
                              fill="white"
                              transform="translate(0.929688 0.880371)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* SECTION 7 */}
      <OpenAccount />
      {/* SECTION 8 */}
      <div className="overflow-hidden lg:container mx-auto flex flex-wrap md:flex-nowrap justify-between w-full gap-6 my-8 lg:my-36">
        <div
          className="hidden md:flex text-left flex-col justify-start items-start px-4 gap-10"
          style={{
            flexShrink: 0,
          }}
        >
          <h2
            className="text-4xl font-semibold"
            style={{
              color: "#233143",
            }}
          >
            Where to find us
          </h2>
          <div
            style={{
              flexShrink: 0,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="185"
              height="208"
              viewBox="0 0 185 208"
              fill="none"
            >
              <path
                d="M184.334 202.9C184.197 204.204 184.056 205.457 182.659 206.588C181.26 207.722 180.002 207.597 178.695 207.459C175.411 206.43 141.131 193.41 104.57 176.838C86.2662 168.541 67.3946 159.356 51.5577 150.341C35.7149 141.323 22.9278 132.485 16.7753 124.888C-9.03237 93.0199 -4.0127 45.7018 30.0378 18.1268C64.0883 -9.44827 111.416 -4.52285 137.224 27.3452C143.523 35.1239 149.538 49.5961 155.037 67.0469C160.534 84.4916 165.509 104.893 169.738 124.512C173.967 144.132 177.448 162.967 179.956 177.281C181.326 185.095 182.406 191.564 183.159 196.077C183.779 199.789 184.178 202.177 184.334 202.9ZM98.8416 58.358C88.216 45.2372 68.4298 43.1581 55.309 53.7837C42.9118 63.8233 40.8366 83.6099 51.4604 96.7286C62.0825 109.845 81.1423 112.519 94.2673 101.89C107.388 91.2649 109.467 71.4787 98.8416 58.358Z"
                fill="#B5E4F7"
                stroke="#B5E4F7"
                strokeWidth="0.273569"
              />
            </svg>
          </div>
        </div>
        <div className="flex md:hidden text-left justify-start items-center px-4">
          <div
            style={{
              flexShrink: 0,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="54"
              height="59"
              viewBox="0 0 54 59"
              fill="none"
            >
              <path
                d="M40.675 45.8997C40.6504 46.1339 40.625 46.3592 40.374 46.5625C40.1225 46.7662 39.8964 46.7437 39.6616 46.719C39.0714 46.5339 32.9108 44.1941 26.3405 41.2159C23.0512 39.725 19.6598 38.0743 16.8137 36.4542C13.9666 34.8336 11.6686 33.2454 10.563 31.8801C5.92506 26.1531 6.82714 17.6495 12.9464 12.694C19.0656 7.73849 27.5709 8.62363 32.2088 14.3507C33.3409 15.7486 34.4217 18.3494 35.4099 21.4854C36.3978 24.6204 37.292 28.2867 38.0519 31.8126C38.8119 35.3383 39.4375 38.7233 39.8883 41.2956C40.1344 42.6998 40.3284 43.8624 40.4638 44.6734C40.5752 45.3406 40.6468 45.7697 40.675 45.8997ZM25.3111 19.9239C23.4016 17.566 19.8458 17.1924 17.4879 19.1019C15.26 20.9061 14.887 24.462 16.7962 26.8195C18.7051 29.1767 22.1304 29.6573 24.4891 27.7472C26.847 25.8377 27.2206 22.2819 25.3111 19.9239Z"
                fill="#B5E4F7"
                stroke="#B5E4F7"
                strokeWidth="0.0491631"
              />
              <path
                d="M38.2021 43.4932C38.2307 43.6321 38.3134 43.7594 38.4284 43.8383C38.8344 44.1168 39.3795 43.7537 39.2797 43.2676C38.7449 40.6631 38.3016 38.063 37.8703 35.5334C37.6208 34.0698 37.3753 32.6297 37.1184 31.226C36.4167 27.3917 35.6293 23.8226 34.4415 20.7524C33.2539 17.6828 31.6688 15.1192 29.3763 13.2892C27.0852 11.4604 24.0775 10.3562 20.0294 10.2227C19.7104 10.2122 19.3842 10.2957 19.1065 10.4553C18.2538 10.9455 18.0541 11.8972 18.3293 12.7453C18.6049 13.5944 19.3465 14.3037 20.3376 14.3024C23.367 14.2983 25.7198 14.718 27.6138 15.7101C29.5102 16.7035 30.9348 18.2645 32.1187 20.5204C33.3013 22.7735 34.2462 25.7245 35.183 29.5042C36.0222 32.8901 36.8564 36.9481 37.8486 41.7746C37.9642 42.337 38.0819 42.9098 38.2021 43.4932Z"
                fill="#A9DAED"
                stroke="#A9DAED"
                strokeWidth="0.234694"
              />
              <path
                d="M14.6114 26.2994C15.6184 28.4517 17.0951 29.2678 18.0445 29.6535C18.2659 29.7435 18.227 29.9733 17.9895 29.9456C16.4607 29.7676 14.8494 28.7738 13.7725 26.9477C12.3701 23.6742 13.3221 21.5018 14.2119 20.9771C14.9277 20.8479 13.2178 23.3208 14.6114 26.2994Z"
                fill="white"
              />
              <path
                d="M10.0161 26.5829C11.2556 30.8617 13.4034 32.7324 14.5554 33.6791C14.7421 33.8326 14.6257 34.0141 14.4126 33.8999C12.548 32.9011 10.1931 30.6344 8.94575 27.0779C7.36071 21.1843 9.53137 18.0532 10.5061 17.7113C11.2938 17.8957 8.44424 21.1566 10.0161 26.5829Z"
                fill="#E0F9FF"
              />
            </svg>
          </div>
          <div className="text-3xl font-semibold" style={{ color: "#233143" }}>
            Where to find us
          </div>
        </div>
        <section className="align-center w-full px-4">
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8085577459315!2d36.790425074031404!3d-1.2890799986986687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10bacbeeff25%3A0xc13a221e31f03d7b!2sRegus%20-%20Nairobi%2C%20Laiboni%20Center!5e0!3m2!1sen!2ske!4v1684758969095!5m2!1sen!2ske' width='100%' height='450' className='' allowfullscreen='' loading='lazy' />",
            }}
          />
        </section>
      </div>
      {/* SECTION 9 */}
      <div
        className="relative overflow-hidden"
        style={{
          background: "#4B5E7F",
        }}
      >
        <img
          src={about2}
          alt="about"
          className="top-0 -left-20 lg:left-0"
          style={{
            position: "absolute",
          }}
          loading="lazy"
        />
        <img
          src={about}
          alt="about"
          className="-right-34 -bottom-5 lg:right-0 lg:bottom-0"
          style={{
            position: "absolute",
          }}
          loading="lazy"
        />
        <div className="overflow-hidden lg:container mx-auto text-center px-8 py-10 md:py-28 flex items-start gap-4 flex-col md:flex-row">
          <div className="sm:w-full md:w-1/2 flex flex-col items-center justify-center px-2">
            <img src={about1} alt="about bg" loading="lazy" />
          </div>
          <div className="text-left w-full md:w-1/2 z-10 mt-10 md:mt-0">
            <p className="text-3xl lg:text-5xl text-white font-black">
              JOIN US
            </p>
            <div
              className="text-lg mb-8 w-full lg:w-3/4 leading-7 mt-5"
              style={{ color: "rgba(255, 255, 255, 0.87)" }}
            >
              Do you like to challenge the norm and use your imagination to come
              up with creative solutions to everyday problems? We are always
              looking for top-performers who are self-driven, dedicated, and
              ready to work in a fast-paced vibrant tech environment.
            </div>
            <Link to="/join-team">
              <button
                style={{
                  borderRadius: "4px",
                  border: "1px solid var(--White, #FFF)",
                  background: "#FFF",
                  padding: "12px 24.667px",
                  cursor: "pointer",
                }}
              >
                Browse open positions
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
